import { SsoProvidersService } from 'data/services';
import { SsoProvidersServiceInterface } from 'domain/services';
import { makeRemoteGetAllSsoProviders } from 'main/factories/usecases/sso-providers/get-all-sso-providers';

export const makeSsoProvidersService = (): SsoProvidersServiceInterface => {
  return new SsoProvidersService({
    getAllSsoProviders: makeRemoteGetAllSsoProviders(),
  });
};
